import httpClient from './http-client'
import {LOCAL_STORAGE_ACCESS_TOKEN, LOCAL_STORAGE_MODAL_MAP_INFO} from '@/helpers/local_storage_constants';

class AuthService {
    async login(username, password) {
        const client_id = `${process.env.VUE_APP_API_CLIENT_ID}`
        const client_secret = `${process.env.VUE_APP_API_CLIENT_SECRET}`

        const formData = new FormData()
        formData.append('client_id', client_id)
        formData.append('client_secret', client_secret)
        formData.append('username', username)
        formData.append('password', password)

        var object = {}
        formData.forEach((value, key) => object[key] = value)
        var jsonForm = JSON.stringify(object)

        return await httpClient.post(
            `${process.env.VUE_APP_API_CAS_TOKEN}?grant_type=password`, jsonForm
        ).then(response => {
            if (response.data.access_token) {
                localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN, response.data.access_token);
                localStorage.setItem(LOCAL_STORAGE_MODAL_MAP_INFO, true);
            }

            return response.data;
        })
    }

    logout() {
      localStorage.removeItem(LOCAL_STORAGE_MODAL_MAP_INFO);
      localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
    }

  }

  export default new AuthService();
